/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { APIErrorSchema } from "./APIErrorSchema.ts"
import { tokenTypeSchema } from "./tokenTypeSchema.ts"
import { z } from "zod/v4"

/**
 * @description Successful authentication returns an access token.
 */
export const signin200Schema = z.object({
  accessToken: z.string().min(1).describe("Access token for authentication"),
  refreshToken: z
    .string()
    .min(1)
    .describe("Refresh token for obtaining new access tokens"),
  scope: z.string().min(1).describe("Scopes granted to the access token"),
  get tokenType() {
    return tokenTypeSchema.describe('Type of the token, typically "Bearer"')
  },
  expiresAt: z.string().datetime().describe("When the session expires"),
})

/**
 * @description Invalid credentials
 */
export const signin401Schema = APIErrorSchema

/**
 * @description User not found
 */
export const signin404Schema = APIErrorSchema

export const signinMutationRequestSchema = z.object({
  clientID: z.string().min(1).describe("Used for analytics").optional(),
  username: z.string().min(1),
  masterPasswordHash: z.string().min(32),
})

export const signinMutationResponseSchema = signin200Schema
